<template>
  <v-img
    min-height="100vh"
    class="pt-header"
    :src="`${publicPath+'images/imagenes/blog2.jpg'}`"
    gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)"
    style="position: relative;"
    :class="[$vuetify.breakpoint.lgAndUp ? 'px-container' : 'px-5']"
  >
    <v-row my-12>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        :class="[$vuetify.breakpoint.smAndUp ? 'px-12 py-12' : '']"
      >
        <h1
          :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']"
          class="font-weight-bold text-uppercase mb-12 white--text"
        >Preguntas frecuentes</h1>

        <v-expansion-panels :focusable="focusable" multiple v-model="panel">
          <v-expansion-panel v-for="(item, index) in questions" :key="index">
            <v-expansion-panel-header class="headline my-3 font-weight-medium">{{item.q}}</v-expansion-panel-header>
            <v-expansion-panel-content class="title font-weight-regular">{{item.a}}</v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div class="text-center mt-10">
          <br />
          <br />
          <h3 class="white--text pt-10">Si deseas más información marca al:</h3>
          <h1 class="white--text pt-4">800 0000 885</h1>
        </div>
      </v-col>
    </v-row>
  </v-img>
</template>
<style lang="scss" scoped>
.bg-Flex {
  background-size: cover !important;
}
.px-container {
  padding-left: 20%;
  padding-right: 20%;
}
.bg-flex-mobile {
  background-size: cover;
  height: 400px;
  margin-bottom: 1rem;
}
.pt-header {
  padding-top: 120px;
}
</style>
<script>
export default {
  data() {
    return {
      panel: [0, 1, 2, 3],
      focusable: true,
      publicPath: process.env.BASE_URL,
      questions: [
        {
          q: "¿Cómo hago llegar mis documentos?",
          a:
            "Una vez que has completado el pago de la inscripción te enviaremos una guía de paquetería prepagado que llegará a tu domicilio para que envíes la documentación sin costo para ti. Nosotros te confirmaremos cuando la hayamos recibido o podrás hacer un rastreo del paquete vía internet."
        },
        {
          q:
            "¿Desde qué navegador puedo ingresar para poder estudiar en linea?",
          a:
            "La plataforma educativa está diseñada para poder ser abierta desde Google Chrome, Internet Explorer, Firefox, Opera y Safari, por lo que no tendrás problemas para revisar tus cursos en los que estás inscrito."
        },
        {
          q: "¿Puedo saber quiénes serán mis profesores?",
          a:
            "Tus profesores son profesionistas con experiencia profesional y docente en el sistema Vizcaya en sus campus presenciales. Te comentamos que los cursos han sido diseñados por especialistas y serán atendidos por profesores tutores para apoyarte en la resolución de dudas y para la elaboración de las actividades de aprendizaje. Cada curso contiene los créditos correspondientes al equipo de profesionales que participó en su diseño."
        },
        {
          q: "¿Mis profesores están capacitados?",
          a:
            "Gracias a la gran infraestructura de Universidad Vizcaya hemos podido contactar y reclutar a los mejores docentes de cada materia para participar en educación a distancia."
        }
      ]
    };
  },
  computed: {
    image() {
      return this.publicPath + "image/imagenes/pop-up-informes.jpg";
    }
  }
};
</script>